"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FetchNetworkHandler = void 0;
var logger_1 = __importDefault(require("../logger"));
var BaseNetworkHandler_1 = __importDefault(require("./BaseNetworkHandler"));
var FetchNetworkHandler = (function (_super) {
    __extends(FetchNetworkHandler, _super);
    function FetchNetworkHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FetchNetworkHandler.prototype.sendRequest = function (payload) {
        var _a = this.config, authType = _a.authType, authenticator = _a.authenticator, protocol = _a.protocol, host = _a.host, path = _a.path, headers = _a.headers;
        return authenticator
            .authRequest(authType, payload, headers)
            .then(function (authedHeaders) { return new Promise(function (resolve, reject) {
            var url = protocol + "//" + host + path;
            return self.fetch(url, {
                method: 'POST',
                headers: authedHeaders,
                body: payload
            }).then(function (response) {
                logger_1["default"].log('Received response from metrics server. Status code:', response.status, response.statusText);
                if (response.ok) {
                    resolve();
                }
                else {
                    reject({
                        status: response.status,
                        statusText: response.statusText
                    });
                }
            })["catch"](function (reason) {
                reject({
                    status: -1,
                    statusText: reason.message
                });
            });
        }); })["catch"](function (e) {
            logger_1["default"].log('Got error when sending request:', e);
        });
    };
    return FetchNetworkHandler;
}(BaseNetworkHandler_1["default"]));
exports.FetchNetworkHandler = FetchNetworkHandler;
exports["default"] = FetchNetworkHandler;
//# sourceMappingURL=FetchNetworkHandler.js.map